import React from "react";
import {NumericFormat} from "react-number-format";


export const BalanceNumericFormat = React.forwardRef(
    function BalanceNumericFormat(props, ref) {
        const {onChange, ...other} = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                decimalScale={2}
                decimalSeparator="."
                thousandSeparator=' '
                allowedDecimalSeparators={['.', ',']}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            value: values.value,
                        }
                    })
                }}
                valueIsNumericString
            />
        );
    },
);

export default BalanceNumericFormat